import { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '@/data/catalogue';
import { FULL_COLLECTIONS } from '@/data/catalogue_full';

export const useCollections = () => {
  const [collections, setCollections] = useState(FULL_COLLECTIONS);
  useEffect(() => {
    axios
      .get(`${API}/collections`)
      .then((res) => {
        if (res.data?.collections?.length) setCollections(res.data.collections);
      })
      .catch(() => {});
  }, []);
  return collections;
};
